import { writable } from "svelte/store";
import { browser } from "$app/environment";

export type Theme = "light" | "dark";

function getInitial(): Theme {
  if (!browser) return "light";
  const stored = localStorage.getItem("practical-theme");
  if (stored === "dark" || stored === "light") return stored;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export const theme = writable<Theme>(getInitial());

if (browser) {
  // Keep <html class="dark"> and localStorage in sync. The initial class is set
  // pre-paint by the inline bootstrap in app.html; this keeps it correct after toggles.
  theme.subscribe((val) => {
    localStorage.setItem("practical-theme", val);
    document.documentElement.classList.toggle("dark", val === "dark");
  });
}

export function toggleTheme() {
  theme.update((t) => (t === "dark" ? "light" : "dark"));
}
